// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getRankings } from "./get-ranking.action";

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	success: false,
	error: false,
	data: [],
	location: {
		country: null,
		region: null,
	},
};

// ############################################################

// Slice
const mainPageRankingsSlice = createSlice({
	name: "mainPages/rankings",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getRankings
			.addCase(getRankings.pending, (state) => {
				state.loading = true;
				state.loaded = false;
				state.success = false;
				state.error = false;
				state.data = [];
				state.pagination = {
					currentpage: 1,
					totalpages: 1,
				};
			})
			.addCase(getRankings.fulfilled, (state, action) => {
				state.loading = false;
				state.loaded = true;
				state.success = true;
				state.error = false;
				state.data = action.payload.data.users;
				state.location = {
					country: action.payload.data?.location?.country,
					countryId:
						action.payload.data?.location?.country_id || null,
					countryWithRegions:
						action.payload.data?.location?.with_regions,
					region: action.payload.data?.location?.region,
				};
			})
			.addCase(getRankings.rejected, (state) => {
				state.loading = false;
				state.loaded = true;
				state.success = false;
				state.error = true;
			});
	},
});

// ############################################################

export default mainPageRankingsSlice.reducer;

// ############################################################
